import React, { useState, useEffect } from 'react'
import Modal from 'components/modal'

import 'less/edit-sample-size-modal.less'

const EditSampleSizeModal = props => {
  const initialSampleSize = props.initialSampleSize
  const [sampleSize, setSampleSize] = useState(props.initialSampleSize)
  const [showError, setShowError] = useState(false)

  useEffect(() => {
    if (props.showWarning === true) {
      props.openEditSampleSizeWarningModal({ sampleSize: parseInt(sampleSize), initialSampleSize: initialSampleSize })
    } else if (props.showWarning === false) {
      props.updateProjectSampleSize({sampleSize: sampleSize, id: props.projectId, showWarning: props.showWarning})
    }
  }, [props.showWarning], [props.isOpen])

  const putSampleSize = () => {
    if (parseInt(sampleSize) < props.scheduled + props.completed ||parseInt(sampleSize) === 0 ) {
      setShowError(true)
    } else {
      props.getAvModeratorsCount({ id: props.projectId, sampleSize: sampleSize, initialSampleSize: initialSampleSize, showWarningBanner: props.showWarningBanner })
    }
  }

  useEffect(() => {
    setShowError(false)
  }, [sampleSize])


  let enableSubmit = sampleSize !== "" ? props.initialSampleSizeBeforeWarning
  ? (parseInt(props.initialSampleSizeBeforeWarning) !== parseInt(sampleSize)) 
  : ( parseInt(sampleSize) !== parseInt(initialSampleSize)) : false

  let totalInterviews = props.scheduled + props.completed
  
  return (
    <Modal
      isOpen={props.isOpen}
      className="edit-sample-size-modal"
      title={props.t('edit.sample.size.title')}
      submitBtnText={props.t('save.and.confirm')}
      onCancel={props.onClose}
      enableSubmit={enableSubmit}
      onSubmit={() => putSampleSize(e => e.target.value)}
      isSubmitting={props.isSubmitting}
    >
      <p> {props.t('edit.sample.size.message')}</p>
      <div className={`sample-size-container${showError ? "-error" : ""}`}>
        <div className="sample-size-title">
          <span>{props.t('sample.size.title')}</span>
        </div>
        <input
          className="project-input"
          type="number"
          min="0"
          value={sampleSize}
          onChange={e => setSampleSize(e.target.value)}
        />
        {showError &&
          <div className="error-message">
            {parseInt(sampleSize) <= 0 ? props.t('edit.sample.size.0.error.message') :
              <div>
                {props.t('edit.sample.size.error.message')}
                <span> {props.t('edit.sample.size.total.interviews') + totalInterviews + "."} </span>
              </div>
            }
          </div>
        }
      </div>
    </Modal>
  )
}

export default EditSampleSizeModal
